/**
 * @ngdoc enum
 * @name EventCodes
 * @module mx.app
 *
 * @description
 * Represents a set of predefined event codes (names)
 */
export enum EventCodes {
	// (TODO= Events shouldn't be fired to do something, but when something was happend)

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#AppInit
	 */
	AppInit = 'mx.shell.AppInit',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#AvatarMenuItemAdded
	 */
	AvatarMenuItemAdded = 'mx.shell.AvatarMenuItemAdded',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#DisplayModeChanged
	 */
	DisplayModeChanged = 'mx.shell.DisplayModeChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#FailedRequest
	 */
	FailedRequest = 'mx.shell.FailedRequest',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ProfileChanged
	 */
	ProfileChanged = 'mx.shell.ProfileChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ObjectSelectionChanged
	 */
	ObjectSelectionChanged = 'mx.shell.SelectedObjectsChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ActionsContextChanged
	 */
	ActionsContextChanged = 'mx.shell.ActionsContextChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#RouteLoading
	 */
	RouteLoading = 'mx.shell.RouteLoading',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#RouteActivated
	 */
	RouteActivated = 'mx.shell.RoutesActivated',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ShowNavigationChanged
	 */
	ShowNavigationChanged = 'mx.shell.ShowNavigationChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#NavigationLoaded
	 */
	NavigationLoaded = 'mx.shell.NavigationLoaded',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#NavigationChildrenLoaded
	 */
	NavigationChildrenLoaded = 'mx.shell.NavigationChildrenLoaded',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#NavigationReload
	 */
	NavigationReload = 'mx.shell.NavigationReload',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#BeforeNavigationItemClickHandler
	 */
	BeforeNavigationItemClickHandler = 'mx.shell.BeforeNavigationItemClickHandler',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#NavigationItemClicked
	 */
	NavigationItemClicked = 'mx.shell.NavigationItemClicked',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#CurrentNavigationItemChanged
	 */
	CurrentNavigationItemChanged = 'mx.shell.CurrentNavigationItemChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#Search
	 */
	Search = 'mx.shell.Search',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#Search
	 */
	UnifiedSearchConfigChanged = 'mx.shell.UnifiedSearchConfigChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#UnifiedSearchFullscreenViewOpened
	 */
	UnifiedSearchFullscreenViewOpened = 'mx.shell.UnifiedSearchFullscreenViewOpened',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#UnifiedSearchFullscreenViewClosed
	 */
	UnifiedSearchFullscreenViewClosed = 'mx.shell.UnifiedSearchFullscreenViewClosed',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#UnifiedSearchOpenFullscreenViewRequested
	 */
	UnifiedSearchOpenFullscreenViewRequested = 'mx.shell.UnifiedSearchOpenFullscreenViewRequested',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ConversationalAISearchRegistered
	 */
	ConversationalAISearchRegistered = 'mx.shell.ConversationalAISearchRegistered',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SearchByFilter
	 */
	SearchByFilter = 'mx.shell.SearchByFilter',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SearchContextChanged
	 */
	SearchContextChanged = 'mx.shell.SearchContextChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#NavItemClick
	 */
	NavItemClick = 'mx.shell.NavItemClick',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#NavToggled
	 */
	NavToggled = 'mx.shell.NavToggled',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ActionExecuted
	 */
	ActionExecuted = 'mx.shell.ActionExecuted',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ActionStarted
	 */
	ActionStarted = 'mx.shell.ActionStarted',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SidenavAdditionalButtonClick
	 */
	SidenavAdditionalButtonClick = 'mx.shell.SidenavAdditionalButtonClick',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SidePanelViewAdded
	 */
	SidePanelViewAdded = 'mx.shell.SidePanelViewAdded',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SidePanelCurrentViewChanged
	 */
	SidePanelCurrentViewChanged = 'mx.shell.SidePanelCurrentViewChanged',
	SidePanelCurrentViewChangedV2 = 'mx.shell.SidePanelCurrentViewChangedV2',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SidePanelViewClosed
	 */
	SidePanelViewClosed = 'mx.shell.SidePanelViewClosed',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#RefreshCurrentApp
	 */
	RefreshCurrentApp = 'mx.shell.RefreshCurrentApp',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SidePanelViewsReseted
	 * @description Fires on closing all views in {@ref mx.shell:mxSidePanel side panel}
	 */
	SidePanelViewsReseted = 'mx.shell.SidePanelViewsReseted',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SidePanelInProgressViewsChanged
	 * @description Fires when InProgress array was changed
	 */
	SidePanelInProgressViewsChanged = 'mx.shell.SidePanelInProgressViewsChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ObjectRemovedByWizard
	 * @description Fires when object was removed by wizard
	 */
	ObjectRemovedByWizard = 'mx.shell.ObjectRemovedByWizard',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SidePanelVisibility
	 * @description Fires when {@ref mx.shell:mxSidePanel side panel} shows or hides itself
	 */
	SidePanelVisibility = 'mx.shell.SidePanelVisibility',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#SideLayoutWideModeSwitched
	 * @description Fires when {@ref mx.shell:mxSidePanel side panel} changes it's wide mode
	 */
	SideLayoutWideModeSwitched = 'mx.shell.SideLayoutWideModeSwitched',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#WizardClose
	 * @description Fires to inform anybody that wizard closes (TODO: Events shouldn't be fired "to" do something, but "when" something was happend)
	 */
	WizardClose = 'mx.shell.WizardClose',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#WizardPostAction
	 * @description Fires to inform anybody that wizard closes and post-actions are ready to be executed. (TODO: Events shouldn't be fired "to" do something, but "when" something was happend)
	 */
	WizardPostAction = 'mx.shell.WizardPostAction',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ToggleWizardEnabled
	 * @description Fires to prevent or allow running wizard steps (TODO: Events shouldn't be fired "to" do something, but "when" something was happend)
	 */
	ToggleWizardEnabled = 'mx.shell.ToggleWizardEnabled',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ExtraPanelOpened
	 * @description Fires when Extra Panel was opened.
	 */
	ExtraPanelOpened = 'mx.shell.ExtraPanelOpened',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ExtraPanelClosed
	 * @description Fires when Extra Panel was closed.
	 */
	ExtraPanelClosed = 'mx.shell.ExtraPanelClosed',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#FilterPanelPinnedChanged
	 * @description Fires when the filter panel pinned preference changes. Payload: `boolean`.
	 */
	FilterPanelPinnedChanged = 'mx.shell.FilterPanelPinnedChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#GridColumnFiltersPinnedChanged
	 * @description Fires when the grid column filters pinned preference changes. Payload: `boolean`.
	 */
	GridColumnFiltersPinnedChanged = 'mx.shell.GridColumnFiltersPinnedChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#GridRowHeightChanged
	 * @description Fires when the grid row height preference changes. Payload: `number`.
	 */
	GridRowHeightChanged = 'mx.shell.GridRowHeightChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#PageSizeChanged
	 * @description Fires when the page size preference changes. Payload: `number`.
	 */
	PageSizeChanged = 'mx.shell.PageSizeChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#DashboardDescrVisibilityChanged
	 * @description Fires when a dashboard's description visibility preference changes. Payload: `{ navigationId: string; visible: boolean }`.
	 */
	DashboardDescrVisibilityChanged = 'mx.shell.DashboardDescrVisibilityChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#DashboardAutoSwitchIntervalChanged
	 * @description Fires when the dashboard auto-switch interval preference changes. Payload: `number` (seconds, 0 = off).
	 */
	DashboardAutoSwitchIntervalChanged = 'mx.shell.DashboardAutoSwitchIntervalChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#RefreshCurrentView
	 * @description Fires when "RefreshCurrentView" (in SidePanel) clicked.
	 */
	RefreshCurrentView = 'mx.shell.RefreshCurrentView',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#HelpShowText
	 * @description Fires when "HelpShowText" (in link help) clicked.
	 */
	HelpShowText = 'mx.shell.HelpShowText',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#LayoutChanged
	 * @description Fires when Layout was changed because of window resizing,
	 * 				opening/closing/resizign side panel, navigation, side-bar... And also on app init.
	 */
	LayoutChanged = 'mx.shell.LayoutChanged',
	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#ActionsReady
	 * @description Fires when Actions are Ready (loaded and filtered) .
	 */
	ActionsReady = 'mx.shell.ActionsReady',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#DashboardPageConfigurationModeChanged
	 */
	DashboardPageConfigurationModeChanged = 'mx.shell.DashboardPageConfigurationModeChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.SwitchLocalizationMode
	 * @description Fires when User switches localization mode
	 */
	SwitchLocalizationMode = 'mx.shell.SwitchLocalizationMode',

	/**
	 * @ngdoc property
	 * @name mx.shell.AllAjaxComplete
	 * @description 	Fires when all current ajax-requests are completed successfully of with errors
	 * 					(means no one requst in a progress at the momoent)
	 * 					plus several seconds to make sure current bunch of requsts are complete.
	 */
	AllAjaxComplete = 'mx.shell.AllAjaxComplete',

	/**
	 * @ngdoc property
	 * @name mx.shell.SidebarClosed
	 * @description Fires when Sidebar is closing
	 */
	SidebarClosed = 'mx.shell.SidebarClosed',
	SidebarPinned = 'mx.shell.SidebarPinned',
	SidebarOpened = 'mx.shell.SidebarOpened',

	/**
	 * @ngdoc property
	 * @name mx.shell.ForegroundProcessCreated
	 * @description Fires when Foreground process created
	 */
	ForegroundProcessCreated = 'mx.shell.ForegroundProcessCreated',

	ThemeChanged = 'mx.shell.ThemeChanged',

	DialogActionExecuted = 'mx.SolutionBuilderAgent.DialogActionExecuted',
	ObjectDataChanged = 'mx.SolutionBuilderAgent.ObjectDataChanged',
	ObjectTypeChanged = 'mx.SolutionBuilderAgent.ObjectTypeChanged',
	ObjectDataDeleted = 'mx.SolutionBuilderAgent.ObjectDataDeleted',
	ObjectDisplayNameChanged = 'mx.SolutionBuilderAgent.ObjectDisplayNameChanged',
	SearchPageDataChanged = 'mx.SolutionBuilderAgent.SearchPageDataChanged',
	SearchPageViewTypeChanged = 'mx.SolutionBuilderAgent.SearchPageViewTypeChanged',
	SearchGroupToggleExpanded = 'mx.SolutionBuilderAgent.SearchGroupToggleExpanded',
	ForceOpenObjectDetails = 'mx.SolutionBuilderAgent.ForceOpenObjectDetails',
	ForceOpenObjectsGrid = 'mx.SolutionBuilderAgent.ForceOpenObjectsGrid',
	NewWidgetCreated = 'mx.SolutionBuilderAgent.NewWidgetCreated',
	SearchQueryAdded = 'mx.SolutionBuilderAgent.SearchQueryAdded',
	SearchQueryEdited = 'mx.SolutionBuilderAgent.SearchQueryEdited',
	SearchQueryDeleted = 'mx.SolutionBuilderAgent.SearchQueryDeleted',
	SynchronizeWidget = 'mx.SolutionBuilderAgent.SynchronizeWidget',
	AfterViewsLoaded = 'mx.SolutionBuilderAgent.AfterViewsLoaded', //TODO: to remove after removing from ESM workspace
	SearchPageReloaded = 'mx.SolutionBuilderAgent.searchPageReloaded',
	ViewDataLoaded = 'mx.SolutionBuilderAgent.ViewDataLoaded',
	DataQueryListItemClicked = 'mx.SolutionBuilderAgent.DataQueryListItemClicked',
	ReloadLandingPage = 'mx.SolutionBuilderAgent.ReloadLandingPage',
	LandingPageContentLoaded = 'mx.SolutionBuilderAgent.LandingPageContentLoaded',
	ViewDirtyStatusChanged = 'mx.SolutionBuilderAgent.ViewDirtyStatusChanged',
	GridPersonalizationSaved = 'mx.SolutionBuilderAgent.GridPersonalizationSaved',
	ActionConfirmDialogConfirmed = 'mx.SolutionBuilderAgent.ActionConfirmDialogConfirmed',
	ActionConfirmDialogCanceled = 'mx.SolutionBuilderAgent.ActionConfirmDialogCanceled',
	TrackTelemetry = 'mx.app.TrackTelemetry',
	TrackViewTelemetry = 'mx.SolutionBuilderAgent.TrackViewTelemetry',
	ShellAppInitialized = 'mx.shell.AppInitialized',
	SearchGroupingClicked = 'mx.shell.SearchGroupingClicked',
	NavigationCollapsed = 'mx.shell.NavigationCollapsed',

	QueryFiltersPanelFilterSelectionChanged = 'mx.SolutionBuilderAgent.QueryFiltersPanelFilterSelectionChanged',
	QueryFiltersPanelFilterPinChanged = 'mx.SolutionBuilderAgent.QueryFiltersPanelFilterPinChanged',

	ShowGroupByChartButtonClicked = 'mx.SolutionBuilderAgent.ShowGroupByChartButtonClicked',

	DashboardPageInitialized = 'mx.SolutionBuilderAgent.DashboardPageInitialized',

	MxDialogTabChanged = 'mx.SolutionBuilderAgent.MxDialogTabChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#PersonalizationSettingChanged
	 */
	PersonalizationSettingChanged = 'mx.shell.PersonalizationSettingChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#PersonalizationItemsChanged
	 * @description Fires when a personalization item is registered or unregistered via `PersonalizationService.register()` / `unregister()`.
	 */
	PersonalizationItemsChanged = 'mx.SolutionBuilderAgent.PersonalizationItemsChanged',

	/**
	 * @ngdoc property
	 * @name mx.shell.EventCodes#DefaultDialogChanged
	 * @description Fires when a default new/edit/preview dialog personalization is saved.
	 */
	DefaultDialogChanged = 'mx.shell.DefaultDialogChanged',
}
